import React, { useEffect, useState } from 'react';
import 'moment/locale/it';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { UIModal, UIModalBody, UIModalButtons, UiModalInternal } from '../../utilities/Modal';
import UITypography from '../../utilities/Typography';
import { UIFormControlBox } from '../../utilities/Form';
import { UIButton } from '../../utilities/Button';
import { IconCheck } from '@tabler/icons-react';
import { useOffices } from '../../../hooks/Offices/useOffices';
import { useTreatments } from '../../../hooks/Treatments/useTreatments';
import UIInputAutocomplete from '../../utilities/InputSelect';
import { useAccounts } from '../../../hooks/Accounts/useAccounts';
import { useCalendar } from '../../../hooks/Calendar/useCalendar';

const ModalAddCalendarAwaitingAdmin = ({ modalOpen, handleModalClose }) => {
  const [offices, setOffices] = useState([]);
  const [treatments, setTreatments] = useState([]);
  let [patients, setPatients] = useState([]);
  const { onListOffices } = useOffices();
  const { onListTreatmentsDoctor } = useTreatments();
  const { onListUsersAdmin } = useAccounts();
  const { onAddWaitingListAdmin } = useCalendar();
  const [filters, setFilters] = useState({
    query: ''
  });
  const listPatients = async () => {
    let res = await onListUsersAdmin({ filters });
    setPatients(res);
  };

  useEffect(() => {
    if (!modalOpen) return;

    onListOffices({}).then((res) => {
      setOffices(res);
    });

    onListTreatmentsDoctor({}).then((res) => {
      setTreatments(res);
    });

    listPatients().then(() => {});

    return () => {
      setOffices([]);
      setTreatments([]);
      setPatients([]);
    };
  }, [modalOpen]);

  useEffect(() => {
    if (!modalOpen) return;
    listPatients().then(() => {});
  }, [filters]);

  const handleSubmit = async (values) => {
    const { user_id, office_id, treatment_id } = values;

    if (!user_id || !office_id || !treatment_id) {
      toast('Compila tutti i campi', {
        style: {
          fontSize: '14px',
          backgroundColor: '#ff3d00',
          color: '#ffffff'
        }
      });
      return;
    }

    onAddWaitingListAdmin({
      user_id,
      office_id,
      treatment_id
    }).then((res) => {
      toast(res?.response, {
        style: {
          fontSize: '14px',
          backgroundColor: res?.responseStatus ? '#00e676' : '#FF646C',
          color: '#ffffff'
        }
      });
      if (res?.responseStatus) {
        handleInternalClose();
      }
    });
  };

  const handleInternalClose = () => {
    setOffices(null);
    setTreatments(null);
    setPatients([]);
    setFilters({
      query: ''
    });
    handleModalClose();
  };

  return (
    <UIModal open={modalOpen} onClose={handleInternalClose} allowFullScreen={true} className={'modal'}>
      <UiModalInternal
        onClose={handleInternalClose}
        isLoading={offices?.length === 0 || treatments?.length === 0 || patients?.length === 0}
        containerSx={{
          width: '80%',
          maxWidth: '800px'
        }}
      >
        <Formik
          initialValues={{
            user_id: null,
            office_id: null,
            treatment_id: null
          }}
          validationSchema={Yup.object().shape({
            user_id: Yup.number().typeError('Campo obbligatorio').required('Campo obbligatorio'),
            office_id: Yup.number().typeError('Campo obbligatorio').required('Campo obbligatorio'),
            treatment_id: Yup.number().typeError('Campo obbligatorio').required('Campo obbligatorio')
          })}
          onSubmit={(values, { setErrors }) => handleSubmit(values, setErrors)}
          enableReinitialize={true}
        >
          {({ errors, touched, handleSubmit, values, setFieldValue, submitForm }) => (
            <form onSubmit={handleSubmit} id={'appointment-form'}>
              <UIModalBody
                sx={{
                  bgcolor: 'transparent'
                }}
              >
                <UITypography
                  title={"Inserimento paziente in lista d'attesa"}
                  size={'20px'}
                  sxCustom={{
                    textAlign: 'left',
                    color: '#101828',
                    mt: '30px',

                    py: '2px',
                    px: '20px'
                  }}
                />

                <UIFormControlBox error_message={errors?.user_id} label={'Paziente'} error={Boolean(touched.user_id && errors.user_id)}>
                  <UIInputAutocomplete
                    value={Number(values?.user_id)}
                    setValue={(value) => {
                      if (value?.id) {
                        setFieldValue('user_id', value?.id);
                      }
                    }}
                    options={patients?.map((patient) => {
                      return {
                        id: Number(patient?.id),
                        label: `${patient?.name} ${patient?.surname} - ${patient?.email} - ${patient?.phone}`
                      };
                    })}
                    needTimeoutText={false}
                    onTextValueChange={(value) => {
                      if (!value) return;
                      if (value.length < 3) return;
                      setFilters({
                        ...filters,
                        query: !value ? '' : value
                      });
                    }}
                  />
                </UIFormControlBox>
                <UIFormControlBox
                  error_message={errors?.office_id}
                  label={'Clinica'}
                  error={Boolean(touched.office_id && errors.office_id)}
                >
                  <UIInputAutocomplete
                    value={Number(values?.office_id)}
                    setValue={(value) => {
                      if (value?.id) {
                        setFieldValue('office_id', value?.id);
                      }
                    }}
                    options={offices?.map((office) => {
                      return {
                        id: Number(office?.id),
                        label: `${office?.name} - ${office?.city?.name}`
                      };
                    })}
                    needTimeoutText={false}
                  />
                </UIFormControlBox>

                <UIFormControlBox
                  error_message={errors?.treatment_id}
                  label={'Trattamento'}
                  error={Boolean(touched.treatment_id && errors.treatment_id)}
                >
                  <UIInputAutocomplete
                    value={Number(values?.treatment_id)}
                    setValue={(value) => {
                      if (value?.id) {
                        setFieldValue('treatment_id', value?.id);
                      }
                    }}
                    options={treatments?.map((treatment) => {
                      return {
                        id: Number(treatment?.id),
                        label: `${treatment?.name}`
                      };
                    })}
                    needTimeoutText={false}
                  />
                </UIFormControlBox>
              </UIModalBody>

              <UIModalButtons>
                <UIButton type={'submit'} onClick={() => submitForm()} icon={<IconCheck stroke={'1.64'} size={'26px'} />} />
              </UIModalButtons>
            </form>
          )}
        </Formik>
      </UiModalInternal>
    </UIModal>
  );
};
export default ModalAddCalendarAwaitingAdmin;
